var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortsvgrIcon = function SvgSortsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0CBDF",
    fillRule: "evenodd",
    d: "m8.12 12.782-2.4-2.91a.514.514 0 0 1 .12-.763A.64.64 0 0 1 6.2 9H11c.332 0 .6.244.6.545a.5.5 0 0 1-.12.328l-2.4 2.909a.64.64 0 0 1-.84.109.6.6 0 0 1-.12-.11",
    clipRule: "evenodd",
    "data-arrow": "up"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0CBDF",
    fillRule: "evenodd",
    d: "m9.08 3.218 2.4 2.91a.514.514 0 0 1-.12.763A.64.64 0 0 1 11 7H6.2c-.331 0-.6-.244-.6-.545 0-.118.042-.233.12-.328l2.4-2.909a.64.64 0 0 1 .84-.109.6.6 0 0 1 .12.11",
    clipRule: "evenodd",
    "data-arrow": "down"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortsvgrIcon);
export default ForwardRef;